import { Typography, useTheme } from '@mui/material';
import { SelfBillingInvoiceItem } from 'types/graphql';

import { Link, routes } from '@redwoodjs/router';

import { Card, LineItemTable } from 'src/components';
import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
interface InvoiceItemsProps {
    lineItems: SelfBillingInvoiceItem[];
}

export const viewSelfBillingInvoiceColumnHeaders = [
    'Ledger Account',
    'Product/Service',
    'Description',
    'Quantity',
    'Net Amount',
    'Total Line Vat',
    'Line Total',
];

const getCommissionTypeFromDescription = (description) => {
    switch (description) {
        case CommissionType.TERMINAL: {
            return CommissionType.TERMINAL.toLowerCase();
        }
        case CommissionType.ONLINE: {
            return CommissionType.ONLINE.toLowerCase();
        }
        default: {
            return CommissionType.TRANSACTION.toLowerCase();
        }
    }
};

const InvoiceItems = ({ lineItems }: InvoiceItemsProps) => {
    const { palette } = useTheme();

    return (
        <Card gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice Items
            </Typography>
            <LineItemTable
                columnHeaders={viewSelfBillingInvoiceColumnHeaders}
                data={lineItems?.map(
                    ({
                        description,
                        ledgerAccount,
                        lineTotal,
                        commissionStatementId,
                        netAmount,
                        productOrService,
                        totalVat,
                        quantity,
                    }) => {
                        return {
                            quantity,
                            description: (
                                <>
                                    {description}(
                                    <Link
                                        style={{
                                            color: palette.primary.light,
                                        }}
                                        to={routes?.viewCommissionStatement({
                                            id: commissionStatementId.id,
                                            commissionType:
                                                getCommissionTypeFromDescription(description),
                                        })}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Statement ID {commissionStatementId.commissionStatementId}
                                    </Link>
                                    )
                                </>
                            ),
                            commissionStatementId,
                            ledgerAccount,
                            lineTotal,
                            netAmount,
                            productService: productOrService,
                            totalLineVat: totalVat,
                        };
                    }
                )}
            />
        </Card>
    );
};
export default InvoiceItems;
